module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"DevPlay SDK API Documentation","short_name":"sdk api doc","start_url":"/","background_color":"#f7f0eb","theme_color":"#f55d03","display":"standalone","icon":"src/images/devplay_logo.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"d954e0c57000dddea9a7487a62041c5a"},
    },{
      plugin: require('../node_modules/@devsisters/passport/gatsby-browser.js'),
      options: {"plugins":[],"clientId":"pub-client-apidoc","url":"https://auth.devsisters.cloud/auth"},
    }]
